import { CDeliveryChain, defaultSensorPlacement, deleteKeys } from "@ts/ui-models";

type Params = NonNullable<CDeliveryChain['parameters']>;

export function normalizeForwarderParams(forwarderId: string, params: Params): Params {
    let next = { ...params };

    if (forwarderId !== 'impinjIoTDeviceInterface') {
        next = deleteKeys(next, ['inventoryEventTypeId', 'eventLocationId']);
    }

    if (forwarderId !== 'mahvis') {
        next = deleteKeys(next, ['pickEventTypeId', 'dropEventTypeId', 'defaultGNSSCoordinates']);
    }

    const keepInfra = new Set(['mokoMKGW1', 'chainwayRFIDReader', 'impinjSpeedwayConnect']).has(
        forwarderId as any
    );
    if (!keepInfra) {
        next = deleteKeys(next, ['infrastructureInterfaceTypeId']);
    }

    const supportsPresenceUpdate = new Set([
        'zebraIoTConnector',
        'impinjSpeedwayConnect',
        'impinjIoTDeviceInterface',
        'chainwayRFIDReader',
    ]).has(forwarderId as any);

    if (supportsPresenceUpdate) {
        next = {
            ...next,
            presenceTimeoutMs: next.presenceTimeoutMs ?? 5000,
            updateIntervalMs: next.updateIntervalMs ?? 10000,
        };
    } else {
        next = deleteKeys(next, ['presenceTimeoutMs', 'updateIntervalMs']);
    }

    return next;
}


export function normalizeTransporterParams(transporterId: string, params: Params): Params {
    let next = { ...params };

    if (transporterId !== 'discoveryRTLSApp') {
        next = deleteKeys(next, ['mainUniqueIdPrefix', 'sensorPlacementSettings']);
        return next;
    }

    const incoming = next.sensorPlacementSettings;

    if (!Array.isArray(incoming)) {
        return {
            ...next,
            sensorPlacementSettings: defaultSensorPlacement,
        };
    }

    const normalized = incoming.map(item => (item == null ? defaultSensorPlacement[0] : item));

    return {
        ...next,
        sensorPlacementSettings: normalized.length ? normalized : defaultSensorPlacement,
    };
}